<template>
<div>
    <div class="body intro" id="login-main">
        <div class="wrap">
            <h1 class="mb-20"><img v-if="company_logo_file_url !== ''" :src="company_logo_file_url" alt="company logo"></h1>
            <div class="txt-center">
                <h2>{{title}}</h2>
                <p class="preline">
                    신청내역확인 탭에서 로그인 하시면 신청하신 내역을 확인하실 수 있습니다.
                </p>
                <span class="mt-20 font-13 dp-block">수강신청 기간 : {{sugang_start_date.slice(0, 10)}} ~ {{sugang_end_date.slice(0, 10)}}</span>
            </div>
            <div class="box">
                <div class="login-box">
                    <!-- 탭 활성화 css : active -->
                    <ul>
                        <li class="pointer tablinks" @click="selectTab('access')" :class="setColor('access')">신청하기</li>
                        <li class="pointer tablinks" @click="selectTab('login')" :class="setColor('login')">신청내역확인</li>
                    </ul>
                    <!-- 신청하기 탭 -->
                    <div v-if="tabType === 'access'" class="tab-con" id="apply-tab">
                        <div v-if="isOnClass" class="login-input">
                            <label for="" class="dp-block">
                                <!-- <input type="text" placeholder="E-mail을 입력해 주세요." class="w-100per mb-10"> -->
                                <!-- 관리자단에서 회사 메일 주소를 입력했을 경우 -->
                                <span class="company-mail">
                                    <input type="text" v-model="email" placeholder="이메일을 입력해주세요.">
                                    <!-- <span class="ml-05">@samsungds.com</span> -->
                                </span>
                            </label>
                            <!-- 입력오류 시 노출 -->
                            <!-- <p class="txt-red">정확한 E-mail을 입력해 주세요.</p> -->
                            <p></p>
                            <label for="" class="dp-block">
                                <input type="text" v-model="accessCode" placeholder="Access Code를 입력해 주세요." class="w-100per mb-10">
                            </label>
                            <!-- 입력오류 시 노출 -->
                            <!-- <p class="txt-red">Access Code가 일치하지 않습니다. 다시 입력해주세요.</p> -->
                            <p></p>
                            <button>확인</button>
                        </div>

                        <!-- 수강신청이 지났을 경우/시작되기 전 경우 문구 -->
                        <div v-else class="login-txt">
                            <h3 class="bold">수강신청 기간이 아닙니다.</h3>
                            <!-- 수강신청이 지났을 경우 -->
                            <p v-if="!isExpect">
                                수강신청을 하셨을 경우 신청내역확인 탭에서 <br>
                                신청내역을 확인하실 수 있습니다.
                            </p>
                            <!-- 수강신청이 시작되기 전 일 경우 -->
                            <p else>
                                곧 수강신청이 진행될 예정입니다.
                            </p>
                        </div>
                        <div class="contact">
                            <b>Access Code & 문의</b>
                            <button class="float-right">1:1 문의하기</button>
                        </div>
                        <div class="manager-wrap">
                            <p>Access Code는 수강 신청 안내문 mail 혹은 공지에서 확인이 가능하며,
                                확인이 어려울 시 아래의 매니저에게 문의 주시길 바랍니다.
                            </p>
                            <p v-for="(item, index) of qa_admin_info" :key="index">{{item}}</p>
                        </div>
                    </div>
                    <!-- 신청내역확인 탭 -->
                    <div v-else class="tab-con" id="apply-check-tab">
                        <div class="login-input">
                            <label for="" class="dp-block">
                                <input type="text" v-model="email" placeholder="E-mail을 입력해 주세요." class="w-100per mb-10">
                                <!-- 관리자단에서 회사 메일 주소를 입력했을 경우
                                <span class="company-mail">
                                    <input type="text"><span class="ml-05">@samsungds.com</span>
                                </span> -->
                            </label>
                            <label for="" class="dp-block">
                                <input type="password" v-model="password" placeholder="비밀번호를 입력해 주세요." class="w-100per mb-10">
                            </label>
                            <!-- 입력오류 시 노출 -->
                            <!-- <p class="txt-red">E-mail 또는 비밀번호가 일치하지 않습니다.</p> -->
                            <p></p>
                            <button>확인</button>
                            <p class="txt-blue mt-10 underline txt-center pointer">비밀번호를 잊으셨나요? 비밀번호 찾기</p>
                        </div>
                        <div class="contact">
                            <b>Access Code & 문의</b>
                            <button class="float-right">1:1 문의하기</button>
                        </div>
                        <div class="manager-wrap">
                            <p>Access Code는 수강 신청 안내문 mail 혹은 공지에서 확인이 가능하며,
                                확인이 어려울 시 아래의 매니저에게 문의 주시길 바랍니다.
                            </p>
                            <p v-for="(item, index) of qa_admin_info" :key="index">{{item}}</p>
                        </div>

                    </div>
                </div>
                <!-- notice  -->
                <div class="notice">
                    <p class="notice-title">Notice</p>
                    <div class="notice-box">
                        <p class="preline" v-html="info_message">
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    GetUrlParams
} from '@/utils/common.js'
export default {
    data: () => ({
        email: '',
        accessCode: '',
        password: '',
        tabType: 'access',
        isFindPWModalOpened: false, // 비밀번호 찾기 팝업 on/off
        isQnaModalOpened: false, // 1:1 문의 팝업 on/off
        isOnClass: true, // 수강신청 가능 기간인지 여부
        isExpect: true, // 곧 수강신청 예정이 있는지 여부

        pageIdx: '', // 미리보기 api호출을 위한 수강 고유 페이지 idx

        info_message: '', // Notice 내용
        company_logo_file_url: '', // 회사 로고 url
        main_file_url: '', // 메인 배경 url
        pageIdx: '', // 페이지 idx (itm_main_page_idx와 같음)
        point_color: 'Blue', // 메뉴와 버튼 색깔
        qaAdmin: '', // hq 매니저
        qa_admin_info: '', // hq 매니저 정보
        sugang_start_date: '2020-01-01 00:00', // 수강신청 시작 날짜
        sugang_end_date: '2020-12-30 00:00', // 수강신청 종료 날짜
        company_name_direct: '', // 프로그램명 타이틀
        title: '',
        pointColor: 'Blue'
    }),

    watch: {
        // tabType() {
        //     this.reset()
        // }
    },

    mounted() {
        console.log('this.$route.params', this.$route.params)

        var oParams = GetUrlParams()
        this.pageIdx = oParams.pageIdx

        var params = {
            pageIdx: this.pageIdx
        }
        this.axios.get(this.axios.root + this.axios.port + `/sugang/summary/${this.pageIdx}`, params)
            .then(res => {
                console.log('res', res)
                this.title = res.data.title
                for (var item of Object.keys(res.data.summaryInfo)) {
                    if (typeof this[item] !== 'undefined') {
                        this[item] = res.data.summaryInfo[item]
                        // 배경 이미지 변경
                        if (item === 'main_file_url') {
                            document.getElementById("login-main").style.background = `url(${this.main_file_url}) no-repeat center`;
                            document.getElementById("login-main").style['background-size'] = 'cover'
                        }
                    }
                }
                if (this.qa_admin_info !== '') {
                    this.qa_admin_info = this.qa_admin_info.split('^')
                }

                this.pointColor = res.data.summaryInfo.point_color
            }).catch(err => {
                console.log(err)
                alert(err)
            })
    },

    methods: {
        selectTab(type) {
            this.tabType = type
        },

        setColor(type) {
            if (type === this.tabType) {
                if (this.pointColor === 'Blue') {
                    return 'on-blue active'
                } else if (this.pointColor === 'Red') {
                    console.log(122313412)
                    return 'on-red active'
                } else if (this.pointColor === 'Green') {
                    return 'on-green active'
                }
            } else if (type === this.tabType) {
                if (this.pointColor === 'Blue') {
                    return 'on-blue active'
                } else if (this.pointColor === 'Red') {
                    return 'on-red active'
                } else if (this.pointColor === 'Green') {
                    return 'on-green active'
                }
            }
        },

        // 탭 변경시 입력값 초기화
        reset() {
            this.email = ''
            this.accessCode = ''
            this.password = ''
        },

        // 모달 열기
        openModal(type) {
            if (type === 'findPW') {
                this.isFindPWModalOpened = true
            } else if (type === 'qna') {
                this.isQnaModalOpened = true
            }
        },

        // 모달 닫기
        closeModal() {
            if (this.isFindPWModalOpened) {
                this.isFindPWModalOpened = false
            } else if (this.isQnaModalOpened) {
                this.isQnaModalOpened = false
            }
        }
    }
}
</script>
